//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaiduMap from "@/0/components/comMap/comShowBaiduMap.vue";
export default {
  components: {
    "baidu-map": BaiduMap
  },
  props: ["controlItem"],
  data() {
    return {
      lng:0,
      lat:0,
    };
  },
  computed: {
    cellClass: function() {
      return {
        "van-cell": true,
        "van-field": true,
        "van-cell--required": this.controlItem.IsRequired
      };
    }
  },
  created() {
    
    var controlValue = this.controlItem.ControlValue;
    if(!controlValue) return;

    this.lng = controlValue.GpsBd09Lng;
    this.lat = controlValue.GpsBd09Lat;
    //console.log("this.controlItem",this.controlItem);
    setTimeout(async () => {
      var gpsItem = await this.$refs.comBaiduMap.setGps84(this.lng, this.lat);
      if (gpsItem) {
        this.GpsFullAdddress = gpsItem.FullAddress;
      }
      this.$msg.hideLoading();
    }, 200);

  },

  mounted() {
    //this.initDate();
  },
  methods: {
    
  }
};
